export const apiUrl = "https://api.club.rapidsw.kr/";
export const main = "maindata";
export const backend = "backend";
export const frontend = "frontend";
export const mobile = "mobile";
export const profile = "profile";
export const register = "member";
